import { useDarkMode } from "hooks/useDarkMode";
import { memo } from "react";

import darkTheme from "assets/images/dark-theme-toggle-1.svg";
import lightTheme from "assets/images/dark-theme-toggle-2.svg";

export const DarkModeToggle = memo(() => {
  const [isDark, setIsDark] = useDarkMode();
  return (
    <div
      className="flex w-[22px] mr-2 md:mr-4 mx-4 items-center justify-center align-center select-none content-center cursor-pointer"
      onClick={() => {
        setIsDark(!isDark);
      }}
    >
      <img alt="darkThemeToggle" src={isDark ? darkTheme : lightTheme} />
    </div>
  );
});
